module.exports = __webpack_public_path__ + "media/images/athletes/2107-977c9ea06055a02256fcfca1a6ddc5cb.png";